<template>
    <el-dialog :title="title" :visible.sync="showDialog" :show-close=false width="400px" :close-on-click-modal="false">
        <span class="dialog-tip">{{info}}</span>
        <div slot="footer" class="dialog-footer">
            <div class="cs-btn btn-cancel" @click="dismiss">{{$store.state.i18n.cancel[$store.state.CN_EN]}}</div>
            <div class="cs-btn btn-sure" @click="onSureClick">{{$store.state.i18n.ok[$store.state.CN_EN]}}</div>
        </div>
    </el-dialog>
</template>

<script>
    import Vue from 'vue'
    import {
        Dialog
    } from 'element-ui';

    Vue.use(Dialog);

    export default {
        name: "TopTipDialog",
        data() {
            return {
                showDialog: false
            }
        },
        props: {
            title: String,
            info: String,
            onSureClick: {
                type: Function
            }

        },
        methods: {
            dismiss() {
                this.showDialog = false
                // this.$emit('onCloseDialog', false)
            },
            show() {
                this.showDialog = true
            }
        }
    }
</script>

<style scoped>

</style>
